import { IDoctor, IHospital, INursingHome, INursingService, IPharmacy } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

import { DocumentEmailModal } from './document-email.modal';

@Injectable({ providedIn: 'root' })
export class DocumentEmailService {
  constructor(
    private _toastController: ToastController,
    private _translateService: TranslateService,
    private _modalController: ModalController
  ) {}

  public async openEmailModal(
    patientId: string,
    config: { allowIndividualMail: boolean } = { allowIndividualMail: true }
  ): Promise<string[] | { institutionId: string; email: string }[] | undefined> {
    const emailModal = await this._modalController.create({
      component: DocumentEmailModal,
      componentProps: { patientId, config },
      cssClass: 'fullPageModal',
      id: 'emailModal',
    });
    await emailModal.present();
    const modalResult = await emailModal.onDidDismiss();
    return modalResult.data;
  }

  public async openEmailModalForInstitution(
    institutionType: string,
    institution: IHospital | INursingHome | INursingService | IPharmacy | IDoctor,
    config: { allowIndividualMail: boolean } = { allowIndividualMail: true }
  ): Promise<string[] | { institutionId: string; email: string }[] | undefined> {
    const emailModal = await this._modalController.create({
      component: DocumentEmailModal,
      componentProps: { institutionType, institution, config },
      cssClass: 'fullPageModal',
      id: 'emailModal',
    });
    await emailModal.present();
    const modalResult = await emailModal.onDidDismiss();
    return modalResult.data;
  }

  public showEmailOnCompleteMessage(): void {
    this.showToast(this._translateService.instant('audit.detail.toast.send-email'));
  }

  public showResendEmailOnCompleteMessage(): void {
    this.showToast(this._translateService.instant('audit.detail.toast.resend-email'));
  }

  private showToast(message: string, duration: number = 5000): Promise<boolean> {
    return new Promise(async resolve => {
      const toast = await this._toastController.create({
        message: message,
        duration: duration,
        position: 'bottom',
        buttons: [
          {
            text: this._translateService.instant('CLOSE'),
            role: 'cancel',
            handler: async () => {
              resolve(true);
            },
          },
        ],
      });
      await toast.present();
    });
  }
}
